﻿window.SendByEnum = {};

Object.defineProperties(window.SendByEnum, {
    Email:      { value:  "4", writable: false },
    PreComMsg:  { value: "64", writable: false }
});

Object.freeze(window.SendByEnum);